import { put } from "redux-saga/effects";
import { serverRequest } from "../../actions";

export function* addNote3(action) {
  if (action.noSaga) {
    return;
  }
  var payload = {
    action: "portal/addNote3",
    formDataId: action.formDataId,
    note: action.note,
    noteId: action.noteId,
  };
  yield put(serverRequest(payload));
}

export default addNote3;
